import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';

export const apiInterceptorFn = (development: boolean): HttpInterceptorFn => {
  return (req: HttpRequest<any>, next: HttpHandlerFn) => {
    let url = req.url;
    if (shouldPrepend(url)) {
      if (development) {
        url = prependApi(url);
      } else {
        url = prependHost(url);
      }
    }
    return next(req.clone({ url }));
  };
};

function shouldPrepend(url: string) {
  return (
    url.match(/\.svg$/) == null && // Don't proxy svg asset requests
    url.match(/calltrk-user-uploads/) == null && // dont proxy user uploads
    url.match(/https?:\/\//) == null // dont proxy external urls
  );
}

function prependApi(url: string): string {
  // prepend / if its not already
  if (!url.match(/^\//)) {
    url = `/${url}`;
  }
  // prepend /api if its not already
  if (!url.match(/^\/api\//)) {
    url = `/api${url}`;
  }
  return url;
}

function prependHost(url: string): string {
  // prepend / if its not already
  if (!url.match(/^\//)) {
    url = `/${url}`;
  }
  return `${location.protocol}//${location.host}${url}`;
}
